import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { analyticsResultsGETEndipoint } from '../../../common/endpoints';

export const getGMPAnalyticsWorkflowResults = createApi(analyticsResultsGETEndipoint,"GET");

const GMPAnalyticsWorkflowResultsSlice = createSlice({
  name: 'GMPAnalyticsWorkflowResultsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGMPAnalyticsWorkflowResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGMPAnalyticsWorkflowResults.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getGMPAnalyticsWorkflowResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GMPAnalyticsWorkflowResultsSlice.reducer;